/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_CanceledInputs */

const en_settings_billing_tab_canceled = /** @type {(inputs: Settings_Billing_Tab_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const zh_settings_billing_tab_canceled = /** @type {(inputs: Settings_Billing_Tab_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已取消`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Settings_Billing_Tab_CanceledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_canceled = /** @type {((inputs?: Settings_Billing_Tab_CanceledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_CanceledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_tab_canceled(inputs)
	return zh_settings_billing_tab_canceled(inputs)
});
export { settings_billing_tab_canceled as "settings.billing.tab_canceled" }